import Core from "@/modules/core/service/Core";

export default {
    computed: {
        isDisponent () {
            return Core.security.isDisponent();
        },

        isDispatcher () {
            return Core.security.isDispatcher();
        },

        isRestrictedDispatcher () {
            return Core.security.isRestrictedDispatcher();
        },
    }
}